import { createFileRoute } from "@tanstack/react-router"

import { breadcrumbJsonLd, buildHead } from "@/core/seo"

import { ProductPage } from "../components/landing"
import { INVOICING, INVOICING_SEO } from "../content/products/invoicing"

/** Breadcrumb JSON-LD only: SoftwareApplication/Offer wait for final prices and reviews (copy-products.md). */
export const invoicingSeo = () =>
  buildHead({
    ...INVOICING_SEO,
    path: INVOICING.path,
    jsonLd: [breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: INVOICING.name }])],
  })

export const Route = createFileRoute("/_brand-layout/invoicing")({
  head: () => {
    const { meta, links, scripts } = invoicingSeo()
    return { meta, links, scripts }
  },
  component: InvoicingPage,
})

export function InvoicingPage() {
  return <ProductPage content={INVOICING} />
}
